import PropTypes from 'prop-types';
import React from 'react';
import Autosuggest from 'react-autosuggest';
import _ from 'underscore';

import PlacesService from 'common/services/PlacesService';

import styles from './PlacesAutocomplete.css';


const placesService = new PlacesService();
const googleSource = placesService.searchPlaces.bind(placesService);

class PlacesAutocomplete extends React.Component {
  static displayName = 'PlacesAutocomplete';

  static propTypes = {
    alwaysRenderSuggestions: PropTypes.bool,
    focusFirstSuggestion: PropTypes.bool,
    focusInputOnSuggestionClick: PropTypes.bool,
    getSuggestionValue: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onSuggestion: PropTypes.func,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    riderAddresses: PropTypes.object,
    sources: PropTypes.arrayOf(PropTypes.func),
    disableGoogleSource: PropTypes.bool,
    theme: PropTypes.object,
    value: PropTypes.string,
  };

  static defaultProps = {
    getSuggestionValue: (suggestion) => suggestion.name,
    onChange: _.noop,
    onFocus: _.noop,
    onSuggestion: _.noop,
    placeholder: '',
    sources: [],
    disableGoogleSource: false,
  };

  state = {
    value: '',
    suggestions: [],
  };

  componentDidMount() {
    this.dbCallSources = _.debounce(this._callSources, 300);
  }

  _onSuggestionsFetchRequested = ({value}) => {
    const sources = [...this.props.sources];
    if (!this.props.disableGoogleSource) {
      sources.push(googleSource);
    }
    this.dbCallSources(sources, value);
  };

  _callSources = (sources, value) => {
    Promise.all(sources.map((source) => source({input: value})))
      .then((places) => this.setState({suggestions: _.flatten(places)}));
  };

  _onSuggestionsClearRequested = () => {
    if (!this.props.alwaysRenderSuggestions) this.setState({suggestions: []});
  };

  _onSuggestionSelected = (event, {suggestion}) => {
    if (suggestion) {
      this.props.onSuggestion(suggestion);
    }
  };

  _renderSuggestion = (suggestion) => {
    return (
      <div className={styles.suggestionContent} data-id="places-autocomplete-suggestion">
        <div className={styles.label}>
          <div className={styles.name}>{suggestion.name}</div>
          <div className={styles.address}>{suggestion.secondaryText || suggestion.address}</div>
        </div>
      </div>
    );
  };

  render() {
    const inputProps = {
      value: _.isString(this.props.value) ? this.props.value : this.state.value,
      onChange: (event, value) => {
        this.setState({value: value.newValue});
        this.props.onChange(event, value);
      },
      onBlur: (event, {focusedSuggestion}) =>
        this._onSuggestionSelected(event, {suggestion: focusedSuggestion}),
      placeholder: this.props.placeholder,
      onFocus: this.props.onFocus,
      name: this.props.name,
    };

    return (
      <Autosuggest
        alwaysRenderSuggestions={this.props.alwaysRenderSuggestions}
        focusFirstSuggestion={this.props.focusFirstSuggestion}
        focusInputOnSuggestionClick={this.props.focusInputOnSuggestionClick}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this._onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this._onSuggestionsClearRequested}
        onSuggestionSelected={this._onSuggestionSelected}
        getSuggestionValue={this.props.getSuggestionValue}
        renderSuggestion={this._renderSuggestion}
        inputProps={inputProps}
        theme={Object.assign({}, styles, this.props.theme)}
      />
    );
  }
}

export default PlacesAutocomplete;



// WEBPACK FOOTER //
// ./src/common/components/PlacesAutocomplete/PlacesAutocomplete.js